module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('h1', [_vm._v("Acknowledgment")]), _vm._v(" "), _c('p', [_vm._v("I want to thank Michael R. Ritt, a great writer of western fiction and a lifelong friend, whose unceasing encouragement made all the difference in the world.")]), _vm._v(" "), _c('p', [_vm._v("I also want to thank my mother, JoAnn, for a lifetime of love and encouragement. If there is anything within me that is truly good, I learned it by your example, Mom.")]), _vm._v(" "), _c('p', [_vm._v("And finally, I would like to thank my readers. I hope I have delivered within these pages a world you easily slip into and characters you won’t quickly forget.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1f3df42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/ch004.vue
// module id = 72
// module chunks = 0